import { useQuery, QueryFunction } from 'react-query';
import { GetAllTempWorkerQueries, getAllTempWorkers, GetMonthlyTempWorkerParams, getMonthlyTempWorkers, MonthlyTempWorker, TempWorker } from '../../services/apiSLTP/materials/tempWorkers';

type UseTempWorkersQueryOptions = {
    queries?: GetAllTempWorkerQueries;
};

const getTempWorkers: QueryFunction<TempWorker[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTempWorkersQueryOptions];
    const { queries } = options;

    const response = await getAllTempWorkers(queries);
    return response.data;
};

export const useTempWorkersQuery = (options: UseTempWorkersQueryOptions) => {
    return useQuery(['tempWorkers', options], getTempWorkers);
};

type UseMonthlyTempWorkersQueryOptions = {
    params: GetMonthlyTempWorkerParams;
};

const getMonthlyTempWorkersQuery: QueryFunction<MonthlyTempWorker[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlyTempWorkersQueryOptions];
    const { params } = options;

    const response = await getMonthlyTempWorkers(params);
    return response.data;
};

export const useMonthlyTempWorkersQuery = (options: UseMonthlyTempWorkersQueryOptions) => {
    return useQuery(['monthly temp workers', options], getMonthlyTempWorkersQuery);
};
